import { Message } from "../models/Message";
import { clean } from "../utils/utils";
import api from "./api"; // the custom Axios instance
import { Event } from "../models/Event";

const PATH = "/api/v1/messages";

export const MessageService = {
  async createMessage(
    messageData: Omit<
      Message,
      "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
    >,
  ): Promise<string> {
    const response = await api.post(PATH, clean(messageData));
    return response.data.data._id;
  },

  async getMessage(messageId: string): Promise<Message> {
    const response = await api.get(`${PATH}/${messageId}`);
    return response.data.data;
  },

  async getEvents(messageId: string): Promise<Event[]> {
    const res = await api.get(`${PATH}/${messageId}/events`);
    return res.data.data || [];
  },

  async updateMessage(
    messageId: string,
    updatedData: Partial<Omit<Message, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${messageId}`, clean(updatedData));
  },

  async deleteMessage(messageId: string): Promise<void> {
    await api.delete(`${PATH}/${messageId}`);
  },
};
